<template>
  <div>
    <v-dialog width="450" v-model="searchModal">
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-2">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-magnify</v-icon>
              <span class="modal-title-text mr-2">جستجو</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-12">
          <v-row>
            <v-col cols="12">
              <v-text-field type="text" outlined id="user-moveFromStationTime" ref="moveFromStationTime" dense clearable
                autocomplete="off" @click:clear="clearDateTime('searchFromDate')" clear-icon="mdi-close-circle-outline"
                v-model="tempSearchFromDate" @focus="showSearchFromDate = true" @click="showSearchFromDate = true"
                label="از تاریخ" prepend-inner-icon="mdi-calendar-range mdi-18px">
                <template slot="append">
                  <v-icon @click="showSearchFromDate = true" class="calender-background ml-n3 mt-n2" color="white">
                    mdi-calendar-range mdi-18px
                  </v-icon>
                </template>
              </v-text-field>
              <date-picker :show="showSearchFromDate" simple v-model="searchFromDate" type="datetime" @open="onOpen"
                @change="dateTimeChange('searchFromDate')" :editable="true" format="YYYY-MM-DDTHH:mm:ss"
                display-format="HH:mm:ss jYYYY/jMM/jDD" custom-input="#moveFromStationTime-moveFromStationTime"
                @close="showSearchFromDate = false" />
            </v-col>
            <v-col cols="12">
              <v-text-field type="text" outlined id="user-arriveToLocationTime" ref="arriveToLocationTime" dense
                autocomplete="off" clearable @click:clear="clearDateTime('searchToDate')"
                clear-icon="mdi-close-circle-outline" v-model="tempSearchToDate" @focus="showSearchToDate = true"
                @click="showSearchToDate = true" label="تا تاریخ" prepend-inner-icon="mdi-calendar-range mdi-18px">
                <template slot="append">
                  <v-icon @click="showSearchToDate = true" class="calender-background ml-n3 mt-n2" color="white">
                    mdi-calendar-range mdi-18px
                  </v-icon>
                </template>
              </v-text-field>
              <date-picker :show="showSearchToDate" simple type="datetime" @open="onOpen" v-model="searchToDate"
                @change="dateTimeChange('searchToDate')" :editable="true" format="YYYY-MM-DDTHH:mm:ss"
                display-format="HH:mm:ss jYYYY/jMM/jDD" custom-input="#arriveToLocationTime-arriveToLocationTime"
                @close="showSearchToDate = false" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="search()" dark rounded class="normal-letter-spacing px-12">
            جستجو
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancelSearch()" class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row no-gutters>
      <v-col cols="12" class="mr-2 mt-3">
        <v-card elevation="0" height="88vh" class="main-dashboard-115-card">
          <v-card-text>
            <v-row>
              <v-col cols="2" class="covered-position">
                <span class="current-mission-header-content">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon class="ml-3" v-bind="attrs" v-on="on" @click="refreshList()">
                        mdi-cached mdi-18px
                      </v-icon>
                    </template>
                    <span>به روز رسانی</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" @click="showSearchModal()">
                        mdi-filter mdi-18px
                      </v-icon>
                    </template>
                    <span>فیلتر</span>
                  </v-tooltip>
                </span>
              </v-col>
            </v-row>
            <v-row class="body-card mt-n3">
              <v-col cols="3">
                <v-card height="15vh" class="data-card1" elevation="0">
                  <v-card-text>
                    <v-row no-gutters>
                      <v-col cols="2">
                        <v-icon color="darkColor" class="data-card-icon">
                          mdi-phone mdi-flip-h mdi-18px
                        </v-icon>
                      </v-col>
                      <v-col cols="5" class="mr-3">
                        <h2 class="data-card-title">مجموع تماس ها</h2>
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col cols="3" class="text-left">
                        <h2 class="data-card-content">
                          {{ callsCount }}
                        </h2>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="3">
                <v-card height="15vh" class="data-card2" elevation="0">
                  <v-card-text>
                    <v-row no-gutters>
                      <v-col cols="2">
                        <v-icon color="darkColor" class="data-card-icon">
                          mdi-car-emergency mdi-18px
                        </v-icon>
                      </v-col>
                      <v-col cols="5" class="mr-3">
                        <h2 class="data-card-title">مجموع فوریت ها</h2>
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col cols="3" class="text-left">
                        <h2 class="data-card-content">
                          {{ accidentsCount }}
                        </h2>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="3">
                <v-card height="15vh" class="data-card3" elevation="0">
                  <v-card-text>
                    <v-row no-gutters>
                      <v-col cols="2">
                        <v-icon color="darkColor" class="data-card-icon">
                          mdi-car-emergency mdi-18px
                        </v-icon>
                      </v-col>
                      <v-col cols="5" class="mr-3">
                        <h2 class="data-card-title">مجموع ماموریت ها</h2>
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col cols="3" class="text-left">
                        <h2 class="data-card-content">
                          {{ missionPhonesCount }}
                        </h2>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="3">
                <v-card height="15vh" class="data-card4" elevation="0">
                  <v-card-text>
                    <v-row no-gutters>
                      <v-col cols="2">
                        <v-icon color="darkColor" class="data-card-icon">
                          mdi-car-emergency mdi-18px
                        </v-icon>
                      </v-col>
                      <v-col cols="5" class="mr-3">
                        <h2 class="data-card-title">مجموع مددجوها</h2>
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col cols="3" class="text-left">
                        <h2 class="data-card-content">
                          {{ patientsCount }}
                        </h2>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="4">
                <v-card height="37vh" class="detail-115-dashboard-card" elevation="0">
                  <v-row no-gutters class="chart-title">
                    <v-icon color="white" class="chart-title-icon">mdi-ambulance mdi-48px</v-icon>
                    <span class="chart-title-content">اولویت فوریت ها</span>
                  </v-row>
                  <v-card-text>
                    <div id="dashboardPieRankChart" dir="rtl" style="width: inherit">
                      <highcharts :options="dashboardPieRankChartOptions" ref="pieRank"></highcharts>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="4">
                <v-card height="37vh" class="detail-115-dashboard-card" elevation="0">
                  <v-row no-gutters class="chart-title">
                    <v-icon color="white" class="chart-title-icon">
                      mdi-clipboard-list mdi-48px
                    </v-icon>
                    <span class="chart-title-content">فوریت ها</span>
                  </v-row>
                  <v-card-text>
                    <div id="pieGeographicalChart" dir="rtl" style="width: inherit">
                      <highcharts :options="pieGeographicalChartOption" ref="pieRank"></highcharts>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="4">
                <v-card height="37vh" class="detail-115-dashboard-card" elevation="0">
                  <v-row no-gutters class="chart-title">
                    <v-icon color="white" class="chart-title-icon">mdi-cog mdi-48px</v-icon>
                    <span class="chart-title-content">نوع کدهای ماموریت</span>
                  </v-row>
                  <v-card-text>
                    <div id="pieCodeTypeChart" dir="rtl" style="width: inherit">
                      <highcharts :options="pieCodeTypeChartOption" ref="pieRank"></highcharts>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="8">
                <v-card height="37vh" class="detail-115-dashboard-card" elevation="0">
                  <v-row no-gutters class="chart-title">
                    <v-icon color="white" class="chart-title-icon">mdi-phone mdi-48px</v-icon>
                    <span class="chart-title-content">
                      تماس های اداره ارتباطات، هماهنگی و پایش عملیات
                    </span>
                  </v-row>
                  <v-card-text>
                    <div id="pieCodeTypeChart" dir="rtl" style="width: inherit">
                      <highcharts :options="callsColumnChartOptions" ref="pieRank"></highcharts>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="4">
                <v-card height="37vh" class="detail-115-dashboard-card" elevation="0">
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-img :src="dashboardIMG" contain class="second-row-img"></v-img>
                    </v-col>
                  </v-row>
                  <v-card-text class="pa-5 city_roads-cards_section height-full flex-gap-4 flex-col z-1 relative">
                    <section>
                      <div class="flex items-cetner gap-2">
                        <div class="flex-shrink-0">
                          <v-icon color="lightColor" class="data-card-icon mt-0">
                            mdi-clock-time-four mdi-20px
                          </v-icon>
                        </div>
                        <div class="flex items-center city_roads-cards_section-title_custom">
                          از لحظه شروع پاسخگویی کارشناس 115 تا رسیدن بر بالین مددجو
                        </div>
                      </div>
                      <div class="flex-grow justify-between flex gap-1">
                        <div class="flex flex-col justify-center gap-1 max-width city_roads-cards_section-time_section">
                          <div class="width-max text-center">شهری</div>
                          <div class="width-max max-width city_roads-cards_section-time_section-time">
                            {{ callTillArriveToLocationAverageTime.city }}
                          </div>
                        </div>
                        <div class="flex flex-col justify-center gap-1">
                          <div class="width-max">جاده ای</div>
                          <div class="max-width city_roads-cards_section-time_section-time">
                            {{ callTillArriveToLocationAverageTime.road }}
                          </div>
                        </div>
                        <div class="flex flex-col justify-center gap-1 max-width city_roads-cards_section-time_section">
                          <div class="width-max text-center">شهری فنس</div>
                          <div class="width-max max-width city_roads-cards_section-time_section-time">
                            {{ fenceCallTillArriveToLocationAverageTime.city }}
                          </div>
                        </div>
                        <div class="flex flex-col justify-center gap-1">
                          <div class="width-max">جاده ای فنس</div>
                          <div class="max-width city_roads-cards_section-time_section-time">
                            {{ fenceCallTillArriveToLocationAverageTime.road }}
                          </div>
                        </div>
                      </div>
                    </section>
                    <section class="">
                      <!-- moveFromLocationTillArriveToHospitalAverageTime?.city -->
                      <div class="flex items-cetner gap-2">
                        <div class="flex-shrink-0">
                          <v-icon color="lightColor" class="data-card-icon mt-0">
                            mdi-clock-time-four mdi-20px
                          </v-icon>
                        </div>
                        <div class="flex items-center city_roads-cards_section-title_custom">
                          از لحظه حرکت آمبولانس از محل حادثه تا رسیدن به مرکز درمانی
                        </div>
                      </div>
                      <div class="flex-grow justify-between flex gap-1">
                        <div class="flex flex-col justify-center gap-1 max-width city_roads-cards_section-time_section">
                          <div class="width-max text-center">شهری</div>
                          <div class="width-max max-width city_roads-cards_section-time_section-time">
                            {{ moveFromLocationTillArriveToHospitalAverageTime.city }}
                          </div>
                        </div>
                        <div class="flex flex-col justify-center gap-1">
                          <div class="width-max">جاده ای</div>
                          <div class="max-width city_roads-cards_section-time_section-time">
                            {{ moveFromLocationTillArriveToHospitalAverageTime.road }}
                          </div>
                        </div>
                        <div class="flex flex-col justify-center gap-1 max-width city_roads-cards_section-time_section">
                          <div class="width-max text-center">شهری فنس</div>
                          <div class="width-max max-width city_roads-cards_section-time_section-time">
                            {{ fenceMoveFromLocationTillArriveToHospitalAverageTime.city }}
                          </div>
                        </div>
                        <div class="flex flex-col justify-center gap-1">
                          <div class="width-max">جاده ای فنس</div>
                          <div class="max-width city_roads-cards_section-time_section-time">
                            {{ fenceMoveFromLocationTillArriveToHospitalAverageTime.road }}
                          </div>
                        </div>
                      </div>
                    </section>
                  </v-card-text>
                  <!-- <v-card-text class="pa-5">
                    <v-row no-gutters>
                      <v-col cols="12" class="">
                        <v-row no-gutters>
                          <v-col cols="2" class="pa-0">
                            <v-icon color="lightColor" class="data-card-icon"
                              >mdi-clock-time-four mdi-20px</v-icon
                            >
                          </v-col>
                          <v-col cols="5" class="pa-0">
                            <v-row>
                              <v-col cols="12">
                                <h2 class="data-card-calls-count-content">
                                  {{ callTillArriveToLocationAverageTime }}
                                </h2>
                              </v-col>
                            </v-row>
                            <v-row no-gutters>
                              <v-col cols="12">
                                <h2 class="data-card-calls-count-title">
                                  از لحظه شروع پاسخگویی کارشناس 115 تا رسیدن بر
                                  بالین مددجو
                                </h2>
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="5" class="pa-0">
                            <v-row>
                              <v-col cols="12">
                                <v-row>
                                  <v-col
                                    cols="6"
                                    class="text-center data-card-calls-count-content"
                                  >
                                    10:48
                                  </v-col>
                                  <v-col cols="6" class="text-center">
                                    شهری
                                  </v-col>
                                </v-row>
                              </v-col>
                              <v-col cols="12">
                                <v-row>
                                  <v-col
                                    cols="6"
                                    class="text-center data-card-calls-count-content"
                                  >
                                    10:48
                                  </v-col>
                                  <v-col cols="6" class="text-center">
                                    جاده ای
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12">
                        <v-row no-gutters>
                          <v-col cols="2">
                            <v-icon color="lightColor" class="data-card-icon"
                              >mdi-clipboard-text mdi-20px</v-icon
                            >
                          </v-col>
                          <v-col cols="5">
                            <v-row>
                              <v-col cols="12">
                                <h2 class="data-card-calls-count-content">
                                  {{
                                    moveFromLocationTillArriveToHospitalAverageTime
                                  }}
                                </h2>
                              </v-col>
                            </v-row>
                            <h2 class="data-card-calls-count-title">
                              از لحظه حرکت آمبولانس از محل حادثه تا رسیدن به
                              مرکز درمانی
                            </h2>
                          </v-col>
                          <v-col cols="5" class="pa-0">
                            <v-row no-gutters>
                              <v-col cols="12">
                                <v-row no-gutters>
                                  <v-col
                                    cols="6"
                                    class="text-center data-card-calls-count-content"
                                  >
                                    10:48
                                  </v-col>
                                  <v-col cols="6" class="text-center">
                                    شهری
                                  </v-col>
                                </v-row>
                              </v-col>
                              <v-col cols="12">
                                <v-row no-gutters>
                                  <v-col
                                    cols="6"
                                    class="text-center data-card-calls-count-content"
                                  >
                                    10:48
                                  </v-col>
                                  <v-col cols="6" class="text-center">
                                    جاده ای
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text> -->
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card height="37vh" class="detail-115-dashboard-card" elevation="0">
                  <v-row no-gutters class="chart-title">
                    <v-icon color="white" class="chart-title-icon">mdi-cog mdi-48px</v-icon>
                    <span class="chart-title-content">تشخیص های تکنسین</span>
                  </v-row>
                  <v-card-text>
                    <div id="pieCodeTypeChart" dir="rtl" style="width: inherit">
                      <highcharts :options="dignosisColumnChartOptions" ref="pieRank"></highcharts>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card height="37vh" class="detail-115-dashboard-card" elevation="0">
                  <v-row no-gutters class="chart-title">
                    <v-icon color="white" class="chart-title-icon">
                      mdi-clipboard-list mdi-48px
                    </v-icon>
                    <span class="chart-title-content">ماموریت ها</span>
                  </v-row>
                  <v-card-text>
                    <div id="dashboard800LineMissionChart" dir="rtl" style="width: inherit">
                      <highcharts :options="missionLineChart" ref="pieRank"></highcharts>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card height="37vh" class="detail-115-dashboard-card" elevation="0">
                  <v-row no-gutters class="chart-title">
                    <v-icon color="white" class="chart-title-icon">
                      mdi-clipboard-list mdi-48px
                    </v-icon>
                    <span class="chart-title-content">نتایج مددجویان</span>
                  </v-row>
                  <v-card-text>
                    <div id="dashboard800LineMissionChart" dir="rtl" style="width: inherit">
                      <highcharts :options="patientColumnChartOptions" ref="pieRank"></highcharts>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card height="37vh" class="detail-115-dashboard-card" elevation="0">
                  <v-row no-gutters class="chart-title">
                    <v-icon color="white" class="chart-title-icon">
                      mdi-clipboard-list mdi-48px
                    </v-icon>
                    <span class="chart-title-content">نتایج ماموریت ها</span>
                  </v-row>
                  <v-card-text>
                    <div id="dashboard800LineMissionChart" dir="rtl" style="width: inherit">
                      <highcharts :options="missionPhoneColumnChartOptions" ref="pieRank"></highcharts>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import AlertComponent from '@/components/AlertComponent.vue';
import DashboardAmarHelper from '@/Helpers/Amar/DashboardAmarHelper.js';
import SharedHelper from '@/Helpers/Shared';
import DashboardMixin from '@/Mixins/Dashboard/DashboardMixin.js';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
export default {
  name: 'DashboardAmarView',
  title: 'داشبورد آمار',
  components: { AlertComponent },
  mixins: [DashboardAmarHelper, SharedHelper, DashboardMixin, snackBar, ShearedMixin],
  created() {
    this.$root.$refs.DashboardAmar = this;
  },
  mounted() {
    this.mounteLoding();
  },
  beforeDestroy() { },
  data() {
    return {};
  },
  methods: {
    mounte: function () {
      this.setPreTimes();
      this.getStatisticsMainDashboardFunction(this.searchFromDate, this.searchToDate);
    },
  },
};
</script>
<style lang="scss" scoped>
.city_roads-cards_section {
  &-title_custom {
    font-size: 14px;
    font-weight: 600;
    color: #2d3748;
  }

  &-time_section {
    &-time {
      font-size: 24px;
      font-weight: 700;
    }
  }
}
</style>
<style scoped>
.main-dashboard-115-card {
  border-radius: 10px !important;
  border: 1px solid #2edf93 !important;
}

.body-card {
  height: 85vh !important;
  overflow: hidden;
}

.body-card:hover {
  overflow-y: auto;
}

.detail-115-dashboard-card {
  background: var(--background-color) !important;
  border-radius: 15px !important;
}

.data-card1 {
  background: linear-gradient(250deg, var(--dark-color) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

.data-card2 {
  background: linear-gradient(250deg, var(--light-color) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

.data-card3 {
  background: linear-gradient(250deg, var(--one-field-color) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

.data-card4 {
  background: linear-gradient(250deg, var(--new-call-effect) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

>>>.highcharts-credits {
  /*color: black !important;*/
  fill: var(--background-color) !important;
  cursor: auto !important;
}

>>>.highcharts-background {
  fill: var(--background-color) !important;
}

>>>.highcharts-legend-item text {
  fill: var(--dark-color) !important;
}

>>>.highcharts-label span {
  fill: var(--dark-color) !important;
  color: var(--dark-color) !important;
  z-index: 1 !important;
}

>>>.highcharts-reset-zoom text {
  transform: translate(63px, 2px) !important;
}

.card-info-send-mission-scroll {
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

>>>.second-row-img {
  position: absolute;
  margin-top: 22%;
}

>>>.second-row-img2 {
  position: absolute;
  margin-top: 1.5%;
}

.data-card-icon {
  background: white;
  padding: 10px !important;
  border-radius: 50% !important;
  margin-top: 2.5vh;
}

.data-card-title {
  color: white;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  padding-top: 3.3vh !important;
  margin-right: -2vh !important;
}

.data-card-content {
  color: white;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  padding-top: 3.5vh !important;
  letter-spacing: 1.3px;
}

.data-card-calls-count-content {
  color: #2d3748;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  padding-top: 2vh !important;
  letter-spacing: 1.3px;
  position: relative !important;
}

.data-card-calls-count-title {
  color: #2d3748;
  font-size: 13px;
  font-style: normal;
  font-weight: normal;
  margin-top: -2vh !important;
  position: relative !important;
}

.third-row-space {
  width: 20%;
  min-width: 20%;
  max-width: 20%;
}

.covered-position {
  margin-top: -3.5vh !important;
  position: relative;
  z-index: 2;
  padding-top: 1.5rem;
}

.current-mission-header-content {
  font-size: 13px;
  color: var(--dark-color) !important;
  background-image: linear-gradient(to bottom, var(--background-color) 50%, white 50%);
  padding-right: 20px !important;
  padding-left: 20px !important;
}

.chart-title {
  position: absolute;
}

.chart-title-content {
  margin-right: -50px;
  margin-top: 8px;
  font-weight: 500;
  font-size: 15px;
  z-index: 1;
  color: var(--dark-color);
}

.chart-title-icon {
  z-index: 1;
  margin-right: 10px;
  margin-top: 4px;
}
</style>
